import React from 'react';
import PropTypes from 'prop-types';
import CustomControl from './CustomControl';

import { useLanguageState } from '../../contexts/LanguageProvider';


/** React component */
const EventsMapLegend = ({ position }) => {
  const [lang] = useLanguageState();

  return (
    <CustomControl className='leaflet-control-custom leaflet-control-layers' position={position}>
      <details >
        <summary>{lang.map.legend.title}</summary>
        <div style={{ display: 'flex', gap: '8px' }}>
          {/* Magnitude Section */}
          <div>
            <p style={{ marginBottom: '4px' }}>
              <strong>Magnitude</strong>
            </p>
            <table style={{ fontSize: '12px' }}>
              <tbody>
                {/* <tr><td align="center"><span className="circle7"></span></td><td> ≥ 7</td></tr> */}
                <tr><td align="center"><span className="circle6"></span></td><td> ≥6</td></tr>
                <tr><td align="center"><span className="circle5"></span></td><td> 5</td></tr>
                <tr><td align="center"><span className="circle4"></span></td><td> 4</td></tr>
                <tr><td align="center"><span className="circle3"></span></td><td> 3</td></tr>
                <tr><td align="center"><span className="circle2"></span></td><td> 2</td></tr>
                <tr><td align="center"><span className="circle1"></span></td><td>{'<2'}</td></tr>
              </tbody>
            </table>
          </div>

          {/* Event Type Section */}
          <div style={{ maxWidth: '140px', overflowWrap: 'break-word' }}>
            <p style={{ marginBottom: '4px' }}>
              <strong>{lang.map.legend.eventType}</strong>
            </p>
            <table style={{ fontSize: '12px' }}>
              <tbody>
                <tr>
                  <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg height="20" width="20">
                      <circle cx="10" cy="10" r="8" fill="#FFFFFF" stroke="black" />
                    </svg>
                    {lang.map.legend.earthquake}
                  </td>
                </tr>
                <tr>
                  <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg height="20" width="20">
                      <rect width="16" height="16" x="2" y="2" fill="#FFFFFF" stroke="black" />
                    </svg>
                    {lang.map.legend.blast}
                  </td>
                </tr>
                <tr>
                  <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg height="20" width="20">
                      <polygon points="10,2 18,8 14,18 6,18 2,8" fill="#FFFFFF" stroke="black" />
                    </svg>
                    {lang.map.legend.probableBlast}
                  </td>
                </tr>
                <tr>
                  <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg height="20" width="20">
                      <polygon points="10,2 18,10 10,18 2,10" fill="#FFFFFF" stroke="black" />
                    </svg>
                    {lang.map.legend.industryRelated}
                  </td>
                </tr>
                <tr>
                  <td style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                    <div style={{ flexShrink: 0 }}>
                      <svg height="20" width="20">
                        <polygon points="10,2 18,6 18,14 10,18 2,14 2,6" fill="#FFFFFF" stroke="black" />
                      </svg>
                    </div>
                    <div style={{ whiteSpace: 'normal' }}>
                      {lang.map.legend.suspectedIndustryRelated}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg height="20" width="20">
                      <polygon points="2,2 18,2 10,18" fill="#FFFFFF" stroke="black" />
                    </svg>
                    {lang.map.legend.other}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Age Section */}
          <div>
            <p style={{ marginBottom: '4px' }}>
              <strong>{lang.map.legend.age}</strong>
            </p>
            <table style={{ fontSize: '12px' }}>
              <tbody>
                <tr><td className="ageDay"> </td><td> {lang.map.legend.ageDay}</td></tr>
                <tr><td className="ageWeek"> </td><td> {lang.map.legend.ageWeek}</td></tr>
                <tr><td className="ageMonth"> </td><td> {lang.map.legend.ageMonth}</td></tr>
                <tr><td className="ageOlder"> </td><td> {lang.map.legend.ageOlder}</td></tr>
                <tr><td className="circleLatest"> </td><td> {lang.map.legend.latest}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </details>
    </CustomControl >
  );
};

EventsMapLegend.propTypes = {
  position: PropTypes.string
}

EventsMapLegend.defaultProps = {
  position: 'bottomleft'
}

export default EventsMapLegend;